import { Component, Input } from '@angular/core';
import { TestService } from 'src/app/library/services/test.service';


@Component({
  selector: 'eh-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent {
  @Input() type: 'TEST' | 'IDV' | 'BGV' = 'TEST';
  @Input() email?: string;
  @Input() objectId?: string;
  @Input() employerId?: string;

  selectedRating: number = 0;
  hoverRating: number = 0;
  feedbackMessage: string = '';
  feedbackSubmitted: boolean = false;

  get successMessage(): string {
    switch (this.type) {
      case 'TEST':
        return 'Your test has been submitted successfully.';
      case 'IDV':
        return 'Your ID verification has been submitted successfully.';
      case 'BGV':
        return 'Your background verification has been submitted successfully.';
      default:
        return 'Your submission has been completed successfully.';
    }
  }

  get actionType(): string {
    switch (this.type) {
      case 'TEST':
        return 'test';
      case 'IDV':
        return 'ID verification';
      case 'BGV':
        return 'background check';
      default:
        return 'submission';
    }
  }

  constructor(
    private testService: TestService,
    // private snackbarService: SnackbarService
  ) {}

  setRating(rating: number): void {
    this.selectedRating = rating;
  }

  get feedbackType() {
    switch (this.type) {
      case 'TEST':
        return 'TEST';
      case 'IDV':
        return 'ID_VERIFICATION';
      case 'BGV':
        return 'BACKGROUND_VERIFICATION';
      default:
        return 'TEST';
    }
  }
  setHoverRating(rating: number): void {
    this.hoverRating = rating;
  }

  submitFeedback() {
    if (!this.selectedRating) {
      alert("Please provide a rating before submitting.");
      return;
    }

    const feedbackPayload = {
      employerId: '',
      feedback: this.feedbackMessage,
      feedbackType: this.feedbackType,
      id: '',
      objectId: this.objectId,
      rating: this.selectedRating
    };
    this.testService.addFeedback(feedbackPayload).subscribe(
      (response: any) => {
        this.feedbackSubmitted = true;
        // this.snackbarService.showNotifications('Feedback submitted successfully', 'Ok', 'success')

      },
      (error: any) => {
        console.error("Error submitting feedback:", error);
      }
    );
  }

  // submitFeedback(): void {
  //   if (this.selectedRating > 0) {
  //     // Here you would typically call a service to submit the feedback
  //     console.log('Feedback submitted:', {
  //       type: this.type,
  //       rating: this.selectedRating,
  //       message: this.feedbackMessage,
  //       email: this.email
  //     });
      
  //     this.feedbackSubmitted = true;
  //   }
  // }
}
